import { delegateInit } from './BaseShape';
import { Rectangle } from './Rectangle';

const ENTITY_FIELD_NAME = 'SwitchCase';

export default delegateInit(Rectangle, ENTITY_FIELD_NAME);



// WEBPACK FOOTER //
// ./src/render/svg/shapes/SwitchCase.js